import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ConfiguracaoPedidoBalcaoTO } from "layout/topbar/topBar.model";
import { IAbstractModel } from "model/abstract.model";
import { ConfiguracaoDescontoTO } from "pages/Configuracoes/Configuracoes.model";
import { ConfiguracaoConsignadoTO } from "pages/Configuracoes/consignado/configuracao-consignado";
import { FlowConfiguracaoPoliticaVendaDTO } from "pages/Configuracoes/politica-venda/politica-venda.model";
import { deepReset } from "utils/util";

type configuracoesType = {
    configuracaoPedidoBalcao: ConfiguracaoPedidoBalcaoTO;
    configuracaoDesconto: ConfiguracaoDescontoTO;
    configuracaoDescontoAutorizador: { token: string, configuracaoDesconto: ConfiguracaoDescontoTO; };
    canalVendaPadrao: IAbstractModel | null;
    configuracaoConsignado: ConfiguracaoConsignadoTO | null;
    configuracaoPoliticaVenda: FlowConfiguracaoPoliticaVendaDTO | null;
};

const initialState: configuracoesType = {
    configuracaoPedidoBalcao: {
        deposito: { uuid: '', descritivo: '' },
        depositos: [],
        modeloDocumentoFiscal: { name: '', descritivo: '', codigo: '', modelo: '', nome: '', nomeFiscal: '' },
        serieFiscalNFCe: null,
        serieFiscalNFCeOutros: null,
        serieFiscalNFe: null,
        serieFiscalNFeOutros: null,
        tabelaPreco: { uuid: '', descritivo: '' },
        tabelaPrecoPadrao: { uuid: '', descritivo: '' },
        tabelasPreco: [],
        tmfDevolucao: null,
        tmfVenda: null,
        caixasObrigaVendedor: [],
        tmfBrinde: null,
        somarValorBrindeTotalNota: true,
    },
    configuracaoDesconto: {
        uuid: null,
        usuario: "",
        descontoMaximoItem: 0,
        descontoMaximoPedido: 0,
        acrescimoMaximoPedido: 0,
        autorizaDesconto: false
    },
    configuracaoDescontoAutorizador: {
        token: "",
        configuracaoDesconto: {
            uuid: null,
            usuario: "",
            descontoMaximoItem: 0,
            descontoMaximoPedido: 0,
            acrescimoMaximoPedido: 0,
            autorizaDesconto: false
        }
    },
    canalVendaPadrao: null,
    configuracaoConsignado: null,
    configuracaoPoliticaVenda: null,
};

const configuracoes = createSlice({
    name: 'configuracoes',
    initialState,
    reducers: {
        setConfiguracaoPedidoBalcao: (s, { payload }: PayloadAction<ConfiguracaoPedidoBalcaoTO>) => {
            const configuracaoPedidoBalcao = s.configuracaoPedidoBalcao;
            const configuracaoPedidoBalcaoInicial = initialState.configuracaoPedidoBalcao;

            configuracaoPedidoBalcao.deposito = payload.deposito ?? configuracaoPedidoBalcaoInicial.deposito;
            configuracaoPedidoBalcao.depositos = payload.depositos ?? configuracaoPedidoBalcaoInicial.depositos;
            configuracaoPedidoBalcao.modeloDocumentoFiscal = payload.modeloDocumentoFiscal ?? configuracaoPedidoBalcaoInicial.modeloDocumentoFiscal;
            configuracaoPedidoBalcao.serieFiscalNFCe = payload.serieFiscalNFCe ?? configuracaoPedidoBalcaoInicial.serieFiscalNFCe;
            configuracaoPedidoBalcao.serieFiscalNFCeOutros = payload.serieFiscalNFCeOutros ?? configuracaoPedidoBalcaoInicial.serieFiscalNFCeOutros;
            configuracaoPedidoBalcao.serieFiscalNFe = payload.serieFiscalNFe ?? configuracaoPedidoBalcaoInicial.serieFiscalNFe;
            configuracaoPedidoBalcao.serieFiscalNFeOutros = payload.serieFiscalNFeOutros ?? configuracaoPedidoBalcaoInicial.serieFiscalNFeOutros;
            configuracaoPedidoBalcao.tabelaPreco = payload.tabelaPreco ?? configuracaoPedidoBalcaoInicial.tabelaPreco;
            configuracaoPedidoBalcao.tabelaPrecoPadrao = payload.tabelaPreco ?? configuracaoPedidoBalcaoInicial.tabelaPreco;
            configuracaoPedidoBalcao.tabelasPreco = payload.tabelasPreco ?? configuracaoPedidoBalcaoInicial.tabelasPreco;
            configuracaoPedidoBalcao.deposito = payload.deposito ?? configuracaoPedidoBalcaoInicial.deposito;
            configuracaoPedidoBalcao.tmfDevolucao = payload.tmfDevolucao ?? configuracaoPedidoBalcaoInicial.tmfDevolucao;
            configuracaoPedidoBalcao.tmfVenda = payload.tmfVenda ?? configuracaoPedidoBalcaoInicial.tmfVenda;
            configuracaoPedidoBalcao.caixasObrigaVendedor = payload.caixasObrigaVendedor ?? configuracaoPedidoBalcao.caixasObrigaVendedor;
            configuracaoPedidoBalcao.tmfBrinde = payload.tmfBrinde ?? configuracaoPedidoBalcao.tmfBrinde;
            configuracaoPedidoBalcao.somarValorBrindeTotalNota = payload.somarValorBrindeTotalNota ?? configuracaoPedidoBalcaoInicial.somarValorBrindeTotalNota;
        },
        setTabelaPreco: (s, { payload }: PayloadAction<IAbstractModel>) => {
            s.configuracaoPedidoBalcao.tabelaPreco = payload;
        },
        setTabelaPrecoPadrao: (s, { payload }: PayloadAction<IAbstractModel>) => {
            s.configuracaoPedidoBalcao.tabelaPreco = payload;
        },
        resetTabelaPreco: (s) => {
            s.configuracaoPedidoBalcao.tabelaPreco = s.configuracaoPedidoBalcao.tabelaPrecoPadrao;
        },
        setDeposito: (s, { payload }: PayloadAction<IAbstractModel>) => {
            s.configuracaoPedidoBalcao.deposito = payload;
        },
        setDepositoPadrao: (s, { payload }: PayloadAction<IAbstractModel>) => {
            s.configuracaoPedidoBalcao.deposito = payload;
        },
        setConfiguracaoDesconto: (s, { payload }: PayloadAction<ConfiguracaoDescontoTO>) => {
            s.configuracaoDesconto = payload;
        },
        setConfiguracaoDescontoAutorizador: (s, { payload }: PayloadAction<{ token: string, configuracaoDesconto: ConfiguracaoDescontoTO; }>) => {
            s.configuracaoDescontoAutorizador.configuracaoDesconto = payload.configuracaoDesconto;
            s.configuracaoDescontoAutorizador.token = payload.token;
        },
        resetDescontoAutorizador: (s) => {
            s.configuracaoDescontoAutorizador = initialState.configuracaoDescontoAutorizador;
        },
        resetConfiguracoes: (s) => {
            deepReset(s, initialState);
        },
        setCanalVendaPadrao: (s, { payload }: PayloadAction<IAbstractModel | null>) => {
            s.canalVendaPadrao = payload;
        },

        setConsignadoConfiguracao: (s, { payload }: PayloadAction<ConfiguracaoConsignadoTO>) => {
            s.configuracaoConsignado = payload;
        },

        setConfiguracaoPoliticaVenda: (s, { payload }: PayloadAction<FlowConfiguracaoPoliticaVendaDTO>) => {
            s.configuracaoPoliticaVenda = payload;
        },

    },
});

export const {
    setConfiguracaoDesconto,
    setConfiguracaoDescontoAutorizador,
    setConfiguracaoPedidoBalcao,
    setDeposito,
    setDepositoPadrao,
    setTabelaPreco,
    setTabelaPrecoPadrao,
    resetConfiguracoes,
    resetDescontoAutorizador,
    setCanalVendaPadrao,
    setConsignadoConfiguracao,
    setConfiguracaoPoliticaVenda,
    resetTabelaPreco
} = configuracoes.actions;

export const configuracoesReducer = configuracoes.reducer;
